import React from 'react';
import { IIconProps } from './utils';

export const Check = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 18 14"
    width={width}
    {...rest}
  >
    <path d="M17.3839 2.88388C17.872 2.39573 17.872 1.60427 17.3839 1.11612C16.8957 0.627961 16.1043 0.627961 15.6161 1.11612L6.5 10.2322L2.38388 6.11612C1.89573 5.62796 1.10427 5.62796 0.616117 6.11612C0.127961 6.60427 0.127961 7.39573 0.616117 7.88388L5.61612 12.8839C6.10427 13.372 6.89573 13.372 7.38388 12.8839L17.3839 2.88388Z" fill={fill} />
  </svg>
);
